import { type EventEmitter } from 'events';
import MicrophoneStream from 'microphone-stream';

/**
 * MicStream singleton
 * 
 * Note: MicrophoneStream extends Node.js Readable stream at runtime,
 * but the type definitions don't fully reflect this. We cast to include
 * EventEmitter methods like 'on' and 'removeAllListeners'.
 */
class MicStream extends MicrophoneStream {
  private static mediaStream: MediaStream
  private static instance?: MicStream

  private constructor(stream: MediaStream) {
    super()
    this.setStream(stream)
  }

  public static getInstance(): (MicStream & EventEmitter) | undefined {
    if (!MicStream.instance && MicStream.mediaStream) {
      MicStream.instance = new MicStream(MicStream.mediaStream);
    }
    return MicStream.instance as (MicStream & EventEmitter) | undefined
  }

  public static get active() {
    return this.mediaStream.active
  }

  public static setStream(mediaStream: MediaStream) {
    if (MicStream.mediaStream && MicStream.mediaStream.id !== mediaStream.id) {
      MicStream.instance?.stop();
      MicStream.instance = new MicStream(mediaStream);
    }
    MicStream.mediaStream = mediaStream
  }

  public end() {
    // The instance check is sufficient; at runtime this is a Readable stream
    if (MicStream.instance) {
      MicStream.mediaStream && MicStream.mediaStream.getTracks().forEach(track => track.stop())
      MicStream.instance = undefined
    }
  }
}

export default MicStream
